import angular from 'angular';

import routes from './routes';
import translations from './translations';
import auth from './auth';
import datepicker from './datepicker';

const module = angular
    .module('app.config', [])
    .config(routes)
    .config(translations)
    .config(datepicker)
    .run(auth)
    ;

export default module.name;



// WEBPACK FOOTER //
// ./src/app/config/index.js